module.exports = __webpack_public_path__ + "static/media/share-white.952a719f.svg";